export interface Book {
	currentPage: number,
	firstPage: number,
	lastPage: number,
	name: string,
}



export interface PaginationState {
	books: { [key: string]: Book }
}

export enum PaginationActions {
	GO_TO_PAGE = 'GO_TO_PAGE',
	CREATE_NEW_BOOK = 'CREATE_NEW_BOOK',
	CLEAN_BOOKS = 'CLEAN_BOOKS',
}